import { useEffect, useMemo, useRef, useState } from "react";
import { socket } from "../../../../sockets";

interface Props {
  jobItems: Array<{ id: string | number }>;
  refetch: () => void;
}

export const useJobSocketRefetch = ({ jobItems, refetch }: Props) => {
  console.count("render useJobSocketRefetch");

  const visibleJobIds = useMemo(() => jobItems.map((j) => String(j.id)), [jobItems]);

  const joinedRoomsRef = useRef<Set<string>>(new Set());
  const [isConnected, setIsConnected] = useState(socket.connected);

  useEffect(() => {
    const onConnect = () => {
      console.log("Socket conectado para job refetch");
      setIsConnected(true);
    };

    const onDisconnect = () => {
      console.log("Socket desconectado para job refetch");
      setIsConnected(false);
    };

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);

    if (socket.connected) {
      setIsConnected(true);
    }

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
    };
  }, []);

  useEffect(() => {
    console.log("[JobsList perf] socket job ids", {
      jobIds: visibleJobIds.length,
      connected: isConnected,
    });

    if (!isConnected) {
      console.log("Socket no conectado, esperando para unirse a rooms de jobs...");
      return;
    }

    const newSet = new Set(visibleJobIds);

    newSet.forEach((jobId) => {
      const room = `room_job_${jobId}`;

      if (!joinedRoomsRef.current.has(room)) {
        socket.emit("joinJobRoom", room);
        joinedRoomsRef.current.add(room);
        console.log("Unido al room:", room);
      }
    });

    joinedRoomsRef.current.forEach((room) => {
      const jobId = room.replace("room_job_", "");

      if (!newSet.has(jobId)) {
        socket.emit("leaveJobRoom", room);
        joinedRoomsRef.current.delete(room);
        console.log("Salió del room:", room);
      }
    });
  }, [visibleJobIds, isConnected]);

  useEffect(() => {
    const onJobUpdate = (update: any) => {
      const updateId = String(update?.id ?? update?.jobId);

      if (visibleJobIds.includes(updateId)) {
        console.log("Refetch por actualización de job:", updateId);
        refetch();
      }
    };

    socket.on("updateJobStatus", onJobUpdate);
    return () => {
      socket.off("updateJobStatus", onJobUpdate);
    };
  }, [visibleJobIds, refetch]);

  useEffect(() => {
    return () => {
      joinedRoomsRef.current.forEach((room) => {
        socket.emit("leaveJobRoom", room);
      });
      joinedRoomsRef.current.clear();
      console.log("Cleanup: se salió de todos los rooms de jobs");
    };
  }, []);
};
